import InvoiceHeader from "./header"
import InvoiceBody from "./body"
import InvoiceFooter from "./footer"
import InvoiceDisclaimer from "./disclaimer"
import InvoiceFooterLinks from "./footer-links"
import { SystemUsageData } from "../../../types"

interface Props {
  className?: string
  companyName?: string
  invoiceTimestamp: number
  usage: SystemUsageData
}

const Invoice = ({
  className = "",
  companyName = "",
  invoiceTimestamp,
  usage
}: Props) => (
  <div className={className}>
    <InvoiceHeader
      companyName={companyName}
      invoiceTimestamp={invoiceTimestamp}
    />
    <InvoiceBody usage={usage} />
    <InvoiceFooter usage={usage} />
    <InvoiceDisclaimer usage={usage} />
    <InvoiceFooterLinks />
  </div>
)

export default Invoice
